/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Form,
  message,
  Select,
  Spin,
  Checkbox,
} from "antd";
import { capitalize, checkAlphabets } from "../../utils";
import PinCodeValidator from "../../components/PincodeValidator";
import urls from "../../api/urls";
import API from "../../api";

import Smcs_Loader from "../../assests/images/loader-new.gif";

const { PATCH_BRANCH_DETAILS, GET_CPTYPE_CHECKBOX, GET_RATE_CARD_LIST } = urls;

export const BranchDetails = ({
  handleStepsChange = () => {},
  patchClient,
  branchId,
  branchData,
  goBackStep = () => {},
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [checkBoxList, setCheckBoxList] = useState([]);
  const [checkedList, setCheckedList] = useState([]);
  const [checkBoxRaw, setCheckBoxRow] = useState([]);
  const [hubList, setHubList] = useState([]);
  const [motherHub, setMotherHub] = useState(null);
  // const [fileName, setFileName] = useState(null);
  const [clickedButton, setClickedButton] = useState(null);
  const [selectedBillingId, setSelectedBillingId] = useState(null);

  let lg = 12;
  let sm = 24;
  let md = 12;
  let xs = 24;

  const [rateCardTypeOptions, setRateCardTypeOptions] = useState(null);

  useEffect(() => {
    getRateType();
  }, []);

  useEffect(() => {
    if (branchData?.cpDetail?.cpType) {
      cpTypeOnChange(branchData?.cpDetail?.cpType);
    }
  }, [branchData?.cpDetail?.premiseRbacDto?.rbacs]);

  useEffect(() => {
    if (branchData) {
      const cpDetail = branchData?.branchDDeliveryDetails;
      form.setFieldsValue({
        branchName: cpDetail?.branchName,
        cpType: cpDetail?.cpType,
        motherhubName: capitalize(cpDetail?.motherhubName),
        zone: capitalize(cpDetail?.zone),
        rateCardType: cpDetail?.rateCardType,
        billigCycle: cpDetail?.billingCycle,
        adressLine1: cpDetail?.adressLine1,
        adressLine2: cpDetail?.adressLine2,
        pincode: cpDetail?.pincode,
        city: capitalize(cpDetail?.city),
        stateName: capitalize(cpDetail?.stateName),
        companyMaster: capitalize(cpDetail?.companyMaster),
        centerMaster: capitalize(cpDetail?.centerMaster),
        stateCode: cpDetail?.stateCode,

        // declaredAmount: cpDetail?.declaredAmount,
      });

      let temp = branchData?.premiseRbacDto?.rbacs?.map((item) => ({
        label: item?.module,
        value: item?.rbacId,
      }));
      setSelectedBillingId({
        label: cpDetail?.rateCardType,
        value: cpDetail?.billingConfigId,
        billingCycle: cpDetail?.billingCycle,
      });
      setCheckedList(temp?.map((val) => val.value) || []);
    }
  }, [branchData]);

  async function getRateType() {
    setLoading(true);
    let response = await API.Api(GET_RATE_CARD_LIST).getWithPremiseHeader();
    if (response?.status) {
      setLoading(false);
      let temp = response?.response?.data?.map((item) => ({
        label: item?.rateCardType,
        value: item?.billingId,
        billingCycle: item?.billingCycle,
      }));
      setRateCardTypeOptions(temp);
    } else {
      message.error(response?.response?.data.message || "Network error");
      setLoading(false);
    }
  }

  const handleRateType = (params) => {
    let temp = rateCardTypeOptions?.find((val) => val?.value == params);
    console.log(temp);
    form.setFieldValue("billigCycle", temp?.billingCycle);
    setSelectedBillingId(temp);
  };

  const updateCPDetails = async (formValues) => {
    setLoading(true);

    delete formValues.idUrl;

    if (formValues?.pincode?.toString()?.length < 5) {
      form.setFields([
        {
          name: "pincode",
          errors: ["Please enter valid PIN code"],
        },
      ]);
      setLoading(false);

      return;
    } else {
      //const branchId = localStorage.getItem("branchId");
      const checkBtn = clickedButton === "saveAndContinueButton";

      const selectedOptions = checkBoxRaw?.filter((item) =>
        checkedList?.includes(item.rbacId)
      );
      const filterHub = hubList?.find((val) => {
        if (motherHub) {
          return val?.premiseId === motherHub;
        } else {
          return (
            val?.premiseId === branchData?.branchDDeliveryDetails?.parentId
          );
        }
      });
      const payload = {
        branchId: +branchId,
        branchDDeliveryDetails: {
          ...formValues,
          rateCardType: selectedBillingId?.label,
          billingConfigId: selectedBillingId?.value,
          motherhubName: filterHub?.premiseName,
          parentId: filterHub?.premiseId,
        },
        premiseRbacDto: {
          rbacs: selectedOptions,
        },
      };

      const response = await API.Api(
        PATCH_BRANCH_DETAILS + branchId
      ).putCustomIdHeader(payload);
      if (response?.status) {
        setLoading(false);
        message.success(
          response?.response?.data?.message || "Branch updated successfully."
        );
        if (checkBtn) {
          handleStepsChange(1);
        }
      } else {
        setLoading(false);
        message.error(
          response?.response?.data?.message || "Internal server error."
        );
      }
    }
  };

  const cpTypeOnChange = async (e) => {
    setLoading(true);
    let response = await API.Api(GET_CPTYPE_CHECKBOX + e).get();
    if (response.status) {
      setLoading(false);
      let temp = response?.response?.data?.map((item) => ({
        label: item?.module,
        value: item?.rbacId,
      }));
      setCheckBoxList(temp);
      setCheckBoxRow(response?.response?.data);
    } else {
      setLoading(false);
      setCheckBoxList([]);
      setCheckBoxRow([]);
      message.error(response?.response?.error);
    }
  };

  const handleCheckboxChange = (checkedValue) => {
    setCheckedList([...checkedList, checkedValue]);
    if (checkedList.includes(checkedValue)) {
      setCheckedList(checkedList.filter((value) => value !== checkedValue));
    } else {
      setCheckedList([...checkedList, checkedValue]);
    }
  };

  return (
    <Spin
      spinning={loading}
      size="large"
      indicator={
        <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
      }
    >
      <div>
        <Form
          className="global-form profile-container-form pl-4 pr-4 p-2"
          layout="vertical"
          form={form}
          scrollToFirstError={{
            behavior: "smooth",
            block: "center",
            inline: "center",
          }}
          onFinish={updateCPDetails}
        >
          <Row gutter={40} className="global-form-row">
            <Col span={24} className="mb-1">
              <span className="master-title">Branch Details</span>
              <hr className="divider" />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="branchName"
                label="Branch name"
                rules={[
                  {
                    required: true,
                    message: "Please enter branch name",
                  },
                ]}
                onKeyPress={(event) => {
                  if (checkAlphabets(event)) {
                    event.preventDefault();
                  }
                }}
              >
                <Input
                  placeholder="Enter branch name"
                  // disabled={getData ? true : false}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="cpType"
                label="CP type"
                rules={[
                  {
                    required: true,
                    message: "Please select CP type",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Please select CP type"
                  // options={CpTypeOptions}
                  options={[
                    {
                      value: "Booking",
                      label: "Booking",
                    },
                    {
                      value: "Delivery",
                      label: "Delivery",
                    },
                    {
                      value: "Booking & Delivery",
                      label: "Booking & Delivery",
                    },
                  ]}
                  onSelect={(e) => cpTypeOnChange(e)}
                  // disabled={editView === "edit"}
                />
              </Form.Item>
            </Col>
            {checkBoxList?.length !== 0 && (
              <>
                <Col lg={lg} md={md} sm={sm} xs={xs}></Col>
                <Col lg={lg} md={md} sm={sm} xs={xs}>
                  <Form.Item name="typeOption">
                    {checkBoxList?.map((option, index) => {
                      return (
                        <>
                          <Checkbox
                            key={index}
                            onChange={() => handleCheckboxChange(option?.value)}
                            checked={checkedList?.includes(option?.value)}
                          >
                            {option?.label}
                          </Checkbox>
                        </>
                      );
                    })}
                  </Form.Item>
                </Col>
              </>
            )}

            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="rateCardType"
                label="Rate card type"
                rules={[
                  {
                    required: true,
                    message: "Please select rate card type",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select rate card type"
                  // onChange={handleRateType}
                  // onFocus={getRateType}
                  onSelect={handleRateType}
                  options={rateCardTypeOptions}
                  // disabled={editView === "edit"}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="billigCycle"
                label="Billing cycle"
                rules={[
                  {
                    required: true,
                    message: "Please enter billing cycle",
                  },
                ]}
              >
                {/* <Select
                  showSearch
                  placeholder="Select billing cycle"
                  options={billingCycleOptions}
                  disabled={true}
                /> */}
                <Input placeholder="Enter billing cycle" disabled={true} />
              </Form.Item>
            </Col>
            <Col span={24} className="mb-1">
              <span className="master-title">Address Details</span>
              <hr className="divider" />
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="adressLine1"
                label="Address line 1"
                rules={[
                  {
                    required: true,
                    message: "Please enter address line 1",
                  },
                ]}
              >
                <Input
                  placeholder="Enter address line 1"
                  // disabled={getData ? true : false}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="adressLine2" label="Address line 2">
                <Input
                  placeholder="Enter address line 2"
                  // disabled={getData ? true : false}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <PinCodeValidator formName={"pincode"} />
            </Col>
          </Row>
          <hr className="divider" />
          <div className="flex-end mt-1">
            <Button className="cancel-btn ml-1 w-15" onClick={goBackStep}>
              CANCEL
            </Button>
            {/* <Button className="cancel-btn ml-1  w-15" htmlType="submit">
              SAVE
            </Button> */}
            <Button
              htmlType="submit"
              className="save-btn  ml-1"
              id="saveNContinue"
              onClick={() => setClickedButton("saveAndContinueButton")}
            >
              SAVE & CONTINUE
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default BranchDetails;
